export default __webpack_public_path__ + "static/media/element_28.3790b61a.webp";